/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState } from 'react';
import NumberFormat from 'react-number-format';

// useState

// import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import {
  Table,
  Input,
  InputNumber,
  Popconfirm,
  Form,
  Button,
  Radio,
} from 'antd';
// import moment from 'moment';
// import NumberFormat from 'react-number-format';
import PriceBreakTab from './priceBreakTab';
// import {
//   DownloadOutlined,
//   RightOutlined,
//   LeftOutlined,
// } from '@ant-design/icons';
// // import { Document, Outline, Page } from 'react-pdf';
// import fiftyStates from '../../../config/fiftyStates_copy.json';
// import providence from '../../../config/candianProvinces.json';
// import discountCodes from '../optionsJson/discountCodes.json';

import './pricingTab.scss';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const Header = block => {
  const { values, priceBreakValues, changeValues } = block;
  console.log(priceBreakValues);
  const [form] = Form.useForm();
  const [data, setData] = useState([values]);
  const priceBreakItem = pbData => filter(pbData, { nsnOrPn: values.nsnOrPn });

  const [editingKey, setEditingKey] = useState('');

  const isEditing = record => record.key === editingKey;

  const edit = record => {
    console.log(record);
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async key => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex(item => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
      changeValues('obj', newData);
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const columns = [
    {
      title: 'PR',
      dataIndex: 'pr',
      key: 'pr',
    },
    {
      title: 'Quantity',
      dataIndex: 'qty',
      key: 'qty',
      editable: true,
    },
    {
      title: 'Unit of Issue',
      dataIndex: 'ui',
      key: 'ui',
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrc',
      key: 'unitPrc',
      editable: true,
    },
    {
      title: 'Delivery Days',
      dataIndex: 'dlvryDays',
      key: 'dlvryDays',
      editable: true,
    },
    {
      title: 'operation',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              type="link"
              onClick={() => save(record.key)}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </Button>
            <Popconfirm title="Are You Sure?" onConfirm={cancel}>
              <Button type="link">Cancel</Button>
            </Popconfirm>
          </span>
        ) : (
          <Button
            type="link"
            disabled={editingKey !== ''}
            onClick={() => edit(record)}
          >
            Edit
          </Button>
        );
      },
    },
  ];

  const determineType = dataIndex => {
    switch (dataIndex) {
      case 'unitPrc':
      case 'qty':
        return 'number';

      default:
        return 'text';
    }
  };

  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: record => ({
        record,
        inputType: determineType(col.dataIndex),
        step: '0.01',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <div>
      <div className="tab-wrapper-small">
        <p>NSN/PN: {values.nsnOrPn}</p>{' '}
        <p>Nomenclature: {values.nomenclature}</p>
      </div>
      <div>
        {console.log(data)}
        <Form form={form} component={false}>
          <Table
            pagination={{
              onChange: cancel,
              hideOnSinglePage: true,
            }}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={data}
            columns={mergedColumns}
            rowClassName="editable-row"
          />
        </Form>

        <Form layout="vertical">
          {(values.nsnOrPn.slice(-2) === '53' ||
            values.nsnOrPn.slice(-2) === '52') && (
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Request Waiver of First Article Testing?
                </p>
              }
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Radio.Group
                  value={values.waiver}
                  onChange={e => {
                    changeValues('waiver', e.target.value);
                  }}
                >
                  <Radio value="N">No</Radio>
                  <Radio value="Y">Yes</Radio>
                </Radio.Group>
              </div>
            </Form.Item>
          )}
          <Form.Item>
            <div className="inline">
              <div>
                <p style={{ fontWeight: 800, margin: 0 }}>
                  DO Minimum: {values.doMin}
                </p>
              </div>
              <div>
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Contract Maximum: {values.cntrctMax}
                </p>
              </div>
              <div>
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Annual Frequency of Buys (AFB): {values.afb}
                </p>
              </div>
              <div>
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Guaranteed Minimum: {values.grntdMin}
                </p>
              </div>
            </div>
          </Form.Item>

          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Minimum Order Quantity
              </p>
            }
          >
            <p>
              is a Larger Quantity Obtainable at no additional price due to a
              minimum order quantity
            </p>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Radio.Group
                value={values.minOrderQntyBool}
                onChange={e => {
                  changeValues('minOrderQntyBool', e.target.value);
                }}
              >
                <Radio value="N">No</Radio>
                <Radio value="Y">Yes</Radio>
              </Radio.Group>
              {values.minOrderQntyBool === 'Y' && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p style={{ margin: 0, marginRight: '8px' }}>Quantity:</p>
                  <NumberFormat
                    className="nf-rff-input-field__input form-control"
                    value={values.minOrderQnty}
                    onChange={e => {
                      changeValues('minOrderQnty', e.target.value);
                    }}
                    isAllowed={numvalues => {
                      const { floatValue } = numvalues;
                      return floatValue <= 9999999999;
                    }}
                  />
                </div>
              )}
            </div>
          </Form.Item>
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>Quanity Variance</p>
            }
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p
                style={{
                  fontWeight: 800,
                  margin: 0,
                  fontSize: '16px',

                  marginLeft: '8px',
                  marginRight: '2px',
                }}
              >
                Upper
              </p>
              <NumberFormat
                style={{ width: 100 }}
                className="nf-rff-input-field__input form-control"
                value={values.quantityUpper}
                onChange={e => {
                  changeValues('quantityUpper', e.target.value);
                }}
              />
              <p
                style={{
                  fontWeight: 800,
                  fontSize: '16px',
                  margin: 0,
                  marginLeft: '8px',
                  marginRight: '2px',
                }}
              >
                Lower
              </p>
              <NumberFormat
                className="nf-rff-input-field__input form-control"
                style={{ width: 100 }}
                value={values.quantityLower}
                onChange={e => {
                  changeValues('quantityLower', e.target.value);
                }}
              />
            </div>
          </Form.Item>
          <div style={{ paddingTop: '16px' }}>
            {priceBreakItem(priceBreakValues)[0] && (
              <PriceBreakTab
                values={priceBreakItem(priceBreakValues)}
                changeValues={block.changePriceBreaks}
              />
            )}
            {!priceBreakItem(priceBreakValues)[0] && (
              <Button onClick={() => block.addLinePriceBreaks(values.nsnOrPn)}>
                Add Price Breaks for Line Item{' '}
              </Button>
            )}
            {priceBreakItem(priceBreakValues)[0] && (
              <Button
                onClick={() => {
                  block.addLinePriceBreaks(values.nsnOrPn);
                }}
              >
                Add Price Break Line Item{' '}
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/DibbsTabs/pricingTab.jsx